import React, { useEffect, useState } from "react";
import "./test.css";
import axios from "axios";

export default function TestVideo() {
  const [video, setVideo] = useState(null);
  const [showVideo, setShowVideo] = useState(true);
  const [processedImage, setProcessedImage] = useState(null);
  const [annotatedImage, setAnnotatedImage] = useState(null);
  const [icons, setIcons] = useState([]);

  const getImage = async () => {
    try {
      const response = await axios.get(
        "http://192.168.110.17:8002/last-response",
      );
      console.log(response.data);
      // setImage(response.data.annotated_image_url);
      setProcessedImage(response.data.image);
      setAnnotatedImage(response.data.annotated_image_url);
      setIcons(response?.data?.icons || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getVideo = async () => {
    try {
      const response = await axios.get("http://192.168.110.17:8004/last_result");
      setVideo(response.data.annotated_video_url);
    } catch (error) {
      console.log(error.message);
    }
  };

  // const sendImageToProcess = async (imageUrl) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("image_url", imageUrl);
  //     const response = await axios.post(
  //       "http://192.168.1.21:8007/process",
  //       formData,
  //     );
  //     console.log(response)
  //     setProcessedImage(response?.data?.image);
  //     setAnnotatedImage(response?.data?.annotated_image_url);
  //     setIcons(response?.data?.icons || []);
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  useEffect(() => {
    getImage();
    getVideo();

    const timer = setTimeout(() => {
      setShowVideo(false);
    }, 30000); 

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   if (image) {
  //     sendImageToProcess(image);

  //     const timer = setTimeout(() => {
  //       setShowProcessed(true);
  //     }, 60000); 

  //     return () => clearTimeout(timer);
  //   }
  // }, [image]);

  return (
    <div className="mt-5">
      {showVideo && video && (
        <div className="media-wrapper">
          <video
            src={video}
            autoPlay
            muted
            loop
            controls
            className="media-content"
          />
        </div>
      )}
      {/* {!showVideo && !showProcessed && image && (
        <div className="media-wrapper">
          <img src={image} alt="Result" className="media-content" />
        </div>
      )} */}
      {annotatedImage && processedImage && (
        <div
          className="test-section mx-auto"
          style={{
            height: processedImage?.height,
            width: processedImage?.width,
            backgroundImage: `url(${annotatedImage})`,
          }}
        >
          {icons.map((icon, index) => (
            <div
              key={index}
              className="image-position-test"
              onClick={() => alert(icon?.info?.الاسم)}
              style={{
                left: `${icon?.bbox_px[0]}px`,
                top: `${icon?.bbox_px[1]}px`,
              }}
            >
              <img src={icon.crop_image_url} alt="" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
